import React from 'react';
import styled from 'styled-components';
import { Level, Title } from 'rbx';
import { withRouter } from 'react-router-dom';
import { omit } from 'lodash';
import qs from 'querystringify';
import { Input, Radio } from '../../../components/elements';
import LocationSuggestion from '../../../components/global/LocationSuggestion';

const Wrapper = styled.nav`
  padding: 1rem;
  border-bottom: 1px solid #f5f8fa;
  padding-bottom: 1rem;
`;

const BoxWrapper = styled.nav`
  &&& {
    background: #f6f6f6;
  }
`;

const TitleWrapper = styled.nav`
  padding-right: 0.5rem;
`;

const PlaceSearch = ({
  routeState,
  history,
  placeName,
  city,
  salesType,
  formStatus,
  salesRepEmail,
}) => {
  const handlePush = (args, key) => {
    const newRoutState = omit(routeState, key);
    history.push(
      `/onboards${qs.stringify(
        {
          ...newRoutState,
          ...args,
          page: 1,
        },
        true,
      )}`,
    );
  };

  return (
    <Wrapper>
      <Level>
        <Level.Item align="left">
          <Level.Item>
            <TitleWrapper>
              <Title className="label">Sales Type</Title>
            </TitleWrapper>
          </Level.Item>
          <Level.Item>
            <div>
              <Radio
                label="All"
                name="sales_type"
                value={salesType === 'All'}
                onChange={() => handlePush({ salesType: 'All' }, 'salesType')}
              />
            </div>
          </Level.Item>
          <Level.Item>
            <div>
              <Radio
                label="Lead"
                name="sales_type"
                value={salesType === 'LEAD'}
                onChange={() => handlePush({ salesType: 'LEAD' }, 'salesType')}
              />
            </div>
          </Level.Item>
          <Level.Item>
            <div>
              <Radio
                label="Onboarding"
                name="sales_type"
                value={salesType === 'ONBOARDING'}
                onChange={() =>
                  handlePush({ salesType: 'ONBOARDING' }, 'salesType')
                }
              />
            </div>
          </Level.Item>
        </Level.Item>
        <Level.Item align="left">
          <Level.Item>
            <TitleWrapper>
              <Title className="label">Form Status</Title>
            </TitleWrapper>
          </Level.Item>
          <Level.Item>
            <div>
              <Radio
                label="All"
                name="form_status"
                value={formStatus === 'All'}
                onChange={() => handlePush({ formStatus: 'All' }, 'formStatus')}
              />
            </div>
          </Level.Item>
          <Level.Item>
            <div>
              <Radio
                label="Draft"
                name="form_status"
                value={formStatus === 'DRAFT'}
                onChange={() =>
                  handlePush({ formStatus: 'DRAFT' }, 'formStatus')
                }
              />
            </div>
          </Level.Item>
          <Level.Item>
            <div>
              <Radio
                label="Submitted"
                name="form_status"
                value={formStatus === 'SUBMIT'}
                onChange={() =>
                  handlePush({ formStatus: 'SUBMIT' }, 'formStatus')
                }
              />
            </div>
          </Level.Item>
          <Level.Item>
            <div>
              <Radio
                label="Hold"
                name="form_status"
                value={formStatus === 'HOLD'}
                onChange={() =>
                  handlePush({ formStatus: 'HOLD' }, 'formStatus')
                }
              />
            </div>
          </Level.Item>
          <Level.Item>
            <div>
              <Radio
                label="Inactive"
                name="form_status"
                value={formStatus === 'INACTIVE'}
                onChange={() =>
                  handlePush({ formStatus: 'INACTIVE' }, 'formStatus')
                }
              />
            </div>
          </Level.Item>
          <Level.Item>
            <div>
              <Radio
                label="Completed"
                name="form_status"
                value={formStatus === 'COMPLETED'}
                onChange={() =>
                  handlePush({ formStatus: 'COMPLETED' }, 'formStatus')
                }
              />
            </div>
          </Level.Item>
        </Level.Item>
      </Level>
      <BoxWrapper className="box">
        <div className="columns">
          <div className="column is-4">
            <Input
              label="Place Name"
              type="text"
              id="PlaceManagement_AddEditPlace_SearchPlaceName"
              value={placeName}
              onChange={place => {
                handlePush({ placeName: place.target.value }, 'placeName');
              }}
              placeholder="Start entering place name..."
            />
          </div>

          <div className="column is-4">
            <div className="field">
              <label className="label">City / Suburb</label>
              <div className="control">
                <LocationSuggestion
                  initialValue={city || ''}
                  onSelect={value => {
                    handlePush({ city: value.name }, 'city');
                  }}
                  onHandleClear={() => handlePush({ city: '' }, 'city')}
                  placeholder="Start entering company name..."
                />
              </div>
            </div>
          </div>
          <div className="column is-4">
            <Input
              label="Sales Rep Email"
              type="text"
              id="PlaceManagement_AddEditPlace_SearchCompanyName"
              value={salesRepEmail}
              onChange={event => {
                handlePush(
                  { salesRepEmail: event.target.value },
                  'salesRepEmail',
                );
              }}
              placeholder="Start entering sales rep email..."
            />
          </div>
        </div>
      </BoxWrapper>
    </Wrapper>
  );
};

export default withRouter(PlaceSearch);
